// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3mYTv","upload":"Small_upload__yzJR1","imageWrap":"Small_imageWrap__2Elzu","removeBtn":"Small_removeBtn__2s7WK"};